export default __webpack_public_path__ + "b5f27045605bb307225af4ec698575fa.woff2";